const FACTORY_STANDALONE_ADDON_PRODUCT_IDS = new Set([288, 360]);

export function getOptionsKeyValue(product, key) {
	if (!Array.isArray(product?.product_options)) return false;

	for (const option of product.product_options) {
		if (typeof option.value !== 'string' || !option.value.includes(key)) {
			continue;
		}

		try {
			const value = JSON.parse(option.value)[key];
			if (value) return value;
		} catch (e) {
			continue;
		}
	}

	return false;
}

export function getProductVehicle(product) {
	return [product?.year, product?.make, product?.model]
		.filter(Boolean)
		.join(' ');
}

function getOnlyProductVehicle(products) {
	const vehiclesByKey = new Map();

	for (const product of products) {
		const vehicle = getProductVehicle(product);
		if (!vehicle) continue;

		vehiclesByKey.set(vehicle, vehicle);
	}

	return vehiclesByKey.size === 1 ? vehiclesByKey.values().next().value : '';
}

function getLinkedParentProduct(product, products, orderProducts) {
	const orderProduct = orderProducts.find(
		({ id }) => id === product?.bc_order_item_id,
	);
	const parentId = getOptionsKeyValue(orderProduct, 'parentId');

	if (!parentId) return null;

	const parentOrderProduct = orderProducts.find(
		(orderProduct) =>
			getOptionsKeyValue(orderProduct, 'addOnsParentId') === parentId,
	);

	if (!parentOrderProduct) return null;

	return products.find(
		({ bc_order_item_id }) => bc_order_item_id === parentOrderProduct.id,
	);
}

export function getStandaloneAddonVehicle(
	product,
	products = [],
	orderProducts = [],
) {
	if (!isFactoryStandaloneAddonProduct(product)) return '';

	const vehicle = getProductVehicle(product);
	if (vehicle) return vehicle;

	const parentProduct = getLinkedParentProduct(
		product,
		products,
		orderProducts,
	);
	const parentVehicle = getProductVehicle(parentProduct);
	if (parentVehicle) return parentVehicle;

	const orderProduct = orderProducts.find(
		({ id }) => id === product?.bc_order_item_id,
	);
	const parentId = getOptionsKeyValue(orderProduct, 'parentId');

	return parentId ? getOnlyProductVehicle(products) : '';
}

export function isFactoryStandaloneAddonProduct(product) {
	return FACTORY_STANDALONE_ADDON_PRODUCT_IDS.has(
		Number(product?.bc_item_id ?? product?.product_id),
	);
}

export function shouldNestAddonLineItem(lineItem) {
	return Boolean(
		lineItem?.parentId && !isFactoryStandaloneAddonProduct(lineItem),
	);
}
